<script lang="ts">
    import { closeBottomPopup } from "@components/bottomPopup/bottomPopup.module"
    import Button from "@components/button/Button.svelte"

    type ButtonColor = "blue" | "purple" | "purple-soft" | "white" | "gold" | "danger"
    const buttonColors = new Set<string>([
        "blue",
        "purple",
        "purple-soft",
        "white",
        "gold",
        "danger",
    ])

    function buttonColor(color: string): ButtonColor {
        return buttonColors.has(color) ? (color as ButtonColor) : "blue"
    }

    export let headline: string
    export let detail: string
    export let cancel: () => void = () => null
    export let action: () => void = () => null
    export let buttonLabel: string = "Continue"
    export let secondButtonAction: null | (() => void) = null
    export let secondButtonLabel: null | string = null
    export let secondButtonType = "danger"
    export let cancelButtonlabel = "Cancel"
    export let type = "danger" // danger defaults to the cancel button
</script>

<div>
    {#if headline}
        <h3>{headline}</h3>
    {/if}
    {#if detail}
        <span>{detail}</span>
    {/if}
    <div class="buttons">
        <Button
            color={buttonColor(type)}
            go={() => {
                action()
                closeBottomPopup()
            }}
        >
            {buttonLabel}
        </Button>
        {#if secondButtonAction && secondButtonLabel && secondButtonType}
            <Button
                color={buttonColor(secondButtonType)}
                go={() => {
                    secondButtonAction()
                    closeBottomPopup()
                }}
            >
                {secondButtonLabel}
            </Button>
        {/if}
        <Button
            color="white"
            go={() => {
                cancel()
                closeBottomPopup()
            }}
        >
            {cancelButtonlabel}
        </Button>
    </div>
</div>

<style>
    h3 {
        margin-bottom: 1em;
        text-align: center;
    }

    span {
        display: block;
        margin-bottom: 1em;
        text-align: center;
    }

    .buttons {
        display: grid;
        width: 100%;
        grid-template-columns: repeat(2, max-content);
        gap: 1em;
        justify-items: center;
        align-items: center;
        align-content: center;
        justify-content: center;
    }
</style>
